import React from "react";
import { Spacer, Text, Flex } from "@hubble/web";
import { web } from "@hubble/tokens";

import EmptyStateGraph from "public/images/no_data_available.svg";

import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import Image from "next/image";

const EmptyCoinPriceChart: React.FC = () => {
  const t = useTranslations(FILES.PRICES);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Image src={EmptyStateGraph} alt={t("marketDataUnavailable")} />
      <Spacer mt={1.5} mb={1}></Spacer>
      <Text.Body
        size="md"
        fontWeight={web.text.base.weight.semiBold}
        color={web.color.base.white}
      >
        {t("marketDataUnavailable")}
      </Text.Body>
    </Flex>
  );
};

export default EmptyCoinPriceChart;
